module.exports = __webpack_public_path__ + "static/media/S1N5-4.7e4278ca.svg";